import {
  withDatasourceCheck,
  RichTextField,
  RichText,
  useSitecoreContext,
} from "@sitecore-jss/sitecore-jss-nextjs";
import clsx from "clsx";
import { ComponentProps } from "../../types/component-props";
import styles from "./html-content.module.css";

type RichTextProps = ComponentProps & {
  fields: {
    Text: RichTextField;
  };
};

const HtmlContent = ({ fields, rendering }: RichTextProps) => {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;

  return (
    <RichText
      field={fields.Text}
      className={clsx(
        styles.content,
        rendering.componentName === "Page Rich Text" && styles.pageRichText,
        isEditing && styles.editingSpacing,
      )}
    />
  );
};

export default withDatasourceCheck()<RichTextProps>(HtmlContent);
